module.exports = __webpack_public_path__ + "static/media/image9.814506da.jpg";